import { render, staticRenderFns } from "./electric-warning-edit.vue?vue&type=template&id=bad28b6e&scoped=true&"
import script from "./electric-warning-edit.vue?vue&type=script&lang=js&"
export * from "./electric-warning-edit.vue?vue&type=script&lang=js&"
import style0 from "./electric-warning-edit.vue?vue&type=style&index=0&id=bad28b6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad28b6e",
  null
  
)

export default component.exports